import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

import CareGaps from "./careGaps";
import CareGapsPanels from "./careGapsPanels";
import { getPatientCareGaps } from "apiHandler/actions";
import { useUserData } from "components/customHooks/userDataContext";
import { useLocation } from "react-router-dom";

const CareGapsUI = () => {
  const userData = useUserData();
  const token = userData?.access_token;
  const location = useLocation();
  const rowData = location.state?.data;

  const [careGaps, setCareGaps] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCareGaps();
  }, []);

  const getCareGaps = async () => {
    setLoading(true);
    try {
      const payload = {
        practice_id: rowData.practice_id,
        patient_id: rowData.patient_id,
      };

      const res = await getPatientCareGaps(payload, token);

      setCareGaps(res || []);
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={2}>
      <CareGaps rowData={rowData} fetchData={getCareGaps} />
      <CareGapsPanels
        data={careGaps}
        token={token}
        fetchData={getCareGaps}
        loading={loading}
      />
    </Box>
  );
};

export default CareGapsUI;
